import { DataGridActiveColumns } from '@virtus/components/DataGrid/models';

export const ApplicationDetailsActiveColumns: DataGridActiveColumns = {
  RowKey: true,
  PartitionKey: true,
  TimeStamp: false,
  ActiveDirTenant: true,
  Description: true,
  ActiveDirAppId: false,
  AppInsightInstrumentKey: false,
  AppInsightAppId: false,
  AppInsightApiKey: false,
  AppInsightUrl: false,
  AppInfoUrls: false,
};

export const ApplicationDetailsBaseColumns = {
  RowKey: {
    field: 'RowKey',
    filterPlaceholder: 'Search Application Name',
    width: 250,
  },
  PartitionKey: {
    field: 'PartitionKey',
    filterPlaceholder: 'Search Application Type',
    width: 250,
  },
  TimeStamp: {},
  ActiveDirTenant: {
    field: 'ActiveDirTenant',
    filterPlaceholder: 'Search Tenant',
    width: 250,
  },
  Description: {
    field: 'Description',
    filterPlaceholder: 'Search Description',
    width: 400,
  },
  ActiveDirAppId: {},
  AppInsightInstrumentKey: {},
  AppInsightAppId: {},
  AppInsightApiKey: {},
  AppInsightUrl: {},
  AppInfoUrls: {},
};
export const ApplicationHeaders = [
  {
    caption: 'Application Name',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'RowKey',
    dataType: 'string',
    width: '20%',
  },
  {
    caption: 'Application Type',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'PartitionKey',
    dataType: 'string',
    width: '20%',
  },
  {
    caption: 'Tenant',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'ActiveDirTenant',
    dataType: 'string',
    width: '20%',
  },
  {
    caption: 'Description',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'Description',
    dataType: 'string',
    width: '40%',
  },
];

export const ActionButtons = [
  {
    color: 'black',
    hidden: () => false,
    iconType: 'Edit',
    onClick: () => {},
    tooltip: 'Edit',
  },
  {
    color: 'red',
    hidden: () => false,
    iconType: 'Delete',
    onClick: () => {},
    tooltip: 'Delete',
  },
];
